import React, { useEffect, useRef, useState } from "react";
import { Form, Upload, Tooltip, Image } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useAdjustModel } from "./adjustModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { useDetailModel } from "../detailModel";
import { creditFlagDs } from "../../../../AccountService";
import { useLockFn } from "ahooks";
import FontIcon from "@/components/YhIcon";
import { useGlobalModel } from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { formatLocalDateTime } from "@/utils/utils";
import { getBaseImgLookUrl } from "@/utils/constants";
import moment from 'moment';

export const AdjustMonthDrawer = () => {
    const { getSelectedDict } = useGlobalModel();
    const {
        orgDs,
        beDs,
    } = useDetailModel(model => [
        model.customer,
        model.orgDs,
        model.beDs,
    ]);

    const {
        detail, adjustMonthDrawerVisible, setAdjustMonthDrawerVisible,
    } = useAdjustModel(model => [model.adjustMonthDrawerVisible]);

    const formRef = useRef<IYhFormRef>();
    const [contractType, setContractType] = useState<string>();
    const [uploadFileList, setUploadFileList] = useState<any>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');


    useEffect(() => {
        if (adjustMonthDrawerVisible) {
            load(detail?.code ?? "");
        }
    }, [adjustMonthDrawerVisible])

    const load = async (code: string) => {
        let { retData } = await contractManageService.one(code);
        formRef.current?.setFieldsValue({
            ...retData,
            creditFlag: detail?.creditFlag,
            type: detail?.type,
            startTime: retData?.startTime ? moment(formatLocalDateTime(retData.startTime)) : null,
            endTime: retData?.endTime ? moment(formatLocalDateTime(retData.endTime)) : null,
        })
        setUploadFileList([{
            uid: '-1',
            name: retData?.md5,
            status: 'done',
            url: getBaseImgLookUrl(retData?.md5),
            thumbUrl: getBaseImgLookUrl(retData?.md5),
        }]);
    }

    const contractTypeChange = (value: string, option: any) => {
        if (value) {
            setContractType(value);
            if (value == "contract-type.month") {
                formRef.current?.setFieldsValue({ type: 0 });
            }
            if (value == "contract-type.frame") {
                formRef.current?.setFieldsValue({ type: 1 });
            }
        }
    }

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: true,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "分支",
                fieldName: "branch",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户",
                fieldName: "accountCode",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户",
                fieldName: "accountName",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "授信类型",
                fieldName: "creditFlag",
                disable: true,
                span: 24,
                ds: creditFlagDs(),
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "机构",
                fieldName: "orgCode",
                disable: true,
                span: 24,
                treeDs: orgDs
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "实体",
                fieldName: "beCode",
                disable: true,
                span: 24,
                ds: beDs
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <><Tooltip placement="topLeft" title={(<span> 签约类型为月结协议时，如到期日还存在可用额度，根据合同结束日期顺延10日对该月结账户下授信额度做清0处理。<br />签约类型为临时授信时，额度最长保留10日，10日后不管使没使用都将对该临时调整额度做清0处理。</span>)}><InfoCircleOutlined /></Tooltip><span>签约类型</span></>,
                fieldName: "contractType",
                ds: getSelectedDict(DictCodeEnmu.CONTRACT_TYPE),
                onSelectChange: contractTypeChange,
                rules: [{
                    required: true,
                    message: "请选择月结类型!"
                }],
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调额类型',
                fieldName: "type",
                disable: true,
                span: 24,
                ds: [
                    {
                        label: "目标调额",
                        value: 0
                    },
                    {
                        label: "增量调额",
                        value: 1
                    }
                ]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "调整额度",
                fieldName: "contractAmount",
                span: 24,
                rules: [{
                    required: true,
                    pattern: new RegExp(/^[+]?(\d+)$|^[+]?(\d+\.\d+)$/),
                    message: "请输入大于等于0的数字!"
                }],
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "起始日期",
                fieldName: "startTime",
                format: "YYYY-MM-DD",
                rules: [{
                    required: true,
                    message: "请选择起始日期!"
                }],
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "结束日期",
                fieldName: "endTime",
                format: "YYYY-MM-DD",
                rules: [{
                    required: true,
                    message: "请选择结束日期!"
                }],
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "附件",
                fieldName: "file",
                span: 24,
                colClassName: "ant-col-h-auto",
                formItem: <Form.Item
                    name="fileList"
                    label="附件">
                    <Upload
                        name="file"
                        className="AdjustMonthDrawerUpload2"
                        listType="picture"
                        fileList={uploadFileList}
                        maxCount={1}
                        iconRender={(file) => {
                            if (file?.type?.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                            if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                            if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                        }}
                        onPreview={(file) => {
                            if (file?.url?.indexOf("pdf") != -1 || file?.url?.indexOf("doc") != -1) {
                                window.location.href = file?.url ?? "";
                            }
                            else {
                                setPreviewImage(file?.url);
                                setPreviewOpen(true);
                            }
                        }}
                    >
                    </Upload>
                </Form.Item>,
            },
        ]
    };

    const onOk = useLockFn(async () => {
        setAdjustMonthDrawerVisible(false);
    });

    const onCancel = () => {
        setAdjustMonthDrawerVisible(false);
    };

    return (
        <AppDrawer
            {...{
                title: "账户调额",
                visible: adjustMonthDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm formRef={formRef} {...formConfig} />
            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    src: previewImage,
                    onVisibleChange: value => {
                        setPreviewOpen(value);
                    },
                }}
            />
        </AppDrawer>
    )
}
